import React from "react";
import "../TakeOrder/TakeOrder.css";
import "../TakeOrder/BillComponent.css";

const TakeOverReceipt = React.forwardRef((props, ref) => {
    const {
        storeName,
        gst,
        totalOrders,
        cart,
        products,
        cartPrice,
        categories,
    } = props;

    const itemsTotal = Number(cartPrice?.itemsTotal || 0);
    const addonTotal = Number(cartPrice?.addonTotal || 0);
    const totalPrice = itemsTotal + addonTotal;

    /* =====================================================
       FIND PRODUCT CATEGORY
    ===================================================== */
    const getProductCategory = (item) => {
        const product = (products || []).find(
            (p) =>
                String(p.info?.id) ===
                String(item.product_id)
        );

        if (!product) {
            return null;
        }

        const categoryId =
            product.info?.category_id ||
            product.info?.categoryId ||
            product.category_id;

        return (
            (categories || []).find(
                (c) =>
                    String(c.id) ===
                    String(categoryId)
            ) || null
        );
    };

    /* =====================================================
       BEVERAGE DETECTION
    ===================================================== */
    const isBeverage = (item) => {
        const category = getProductCategory(item);

        if (!category) {
            return false;
        }

        return (
            String(category.name || "")
                .trim()
                .toLowerCase() === "beverages"
        );
    };

    const beverageItems = (cart || []).filter(
        (item) => isBeverage(item)
    );

    const nonBeverageItems = (cart || []).filter(
        (item) => !isBeverage(item)
    );

    const orderNumber = isNaN(totalOrders)
        ? ""
        : Number(totalOrders) + 1;

    /* =====================================================
       ITEM AMOUNT
       ===================================================== */
    const getItemAmount = (item) => {
        // Prefer cartTotal because this is normally the
        // actual cart item amount returned by the cart API.
        if (
            item.cartTotal !== undefined &&
            item.cartTotal !== null
        ) {
            return Math.round(Number(item.cartTotal));
        }

        return Math.round(
            Number(item.quantity || 0) *
            Number(item.itemPrice || 0)
        );
    };

    return (
        <div
            ref={ref}
            className="takeover-print-area"
        >

            {/* =====================================================
                BILL
            ===================================================== */}
            <div className="print-page bill-page">
                <div className="print-bill">

                    <table
                        className="receipt-table"
                        style={{
                            width: "100%",
                            tableLayout: "fixed",
                            borderCollapse: "collapse",
                        }}
                    >
                        <thead>

                            {/* STORE NAME */}
                            <tr>
                                <th
                                    colSpan="2"
                                    className="receipt-center"
                                    style={{
                                        width: "100%",
                                        fontSize: "8px",
                                        padding: "2px 0",
                                    }}
                                >
                                    {storeName}
                                </th>
                            </tr>

                            {/* LINE */}
                            <tr>
                                <td
                                    colSpan="2"
                                >
                                    ------------------------------------------
                                </td>
                            </tr>
                        </thead>
                        <tbody>

                            {/* ORDER NUMBER + DATE + TIME */}
                            <tr>
                                <td
                                    colSpan="2"
                                    style={{
                                        fontSize: "8px",
                                        padding: "2px 0",
                                        textAlign: "left",
                                    }}
                                >
                                    <div>Order No : {orderNumber}</div>

                                    <div>
                                        Date:{" "}
                                        {new Date().toLocaleDateString("en-IN", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric",
                                        })}
                                    </div>

                                    <div>
                                        Time:{" "}
                                        {new Date().toLocaleTimeString("en-IN", {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                        })}
                                    </div>
                                </td>
                            </tr>

                            {/* LINE */}
                            <tr>
                                <td
                                    colSpan="2"
                                >
                                    ------------------------------------------
                                </td>
                            </tr>

                            {/* MENU / AMOUNT HEADER */}
                            <tr>
                                <th
                                    className="menu-column"
                                    style={{
                                        width: "75%",
                                        textAlign: "left",
                                        fontSize: "8px",
                                        padding: "2px 0",
                                    }}
                                >
                                    Menu
                                </th>

                                <th
                                    className="amount-column"
                                    style={{
                                        width: "25%",
                                        textAlign: "center",
                                        fontSize: "8px",
                                        padding: "2px 0",
                                    }}
                                >
                                    Amt
                                </th>
                            </tr>

                            {/* LINE */}
                            <tr>
                                <td
                                    colSpan="2"
                                >
                                    ------------------------------------------
                                </td>
                            </tr>

                            {/* CART ITEMS */}
                            {(cart || []).map(
                                (item, index) => (
                                    <tr key={index}>
                                        <td
                                            className="menu-column item-name"
                                            style={{
                                                width: "75%",
                                                textAlign: "left",
                                                fontSize: "8px",
                                                padding: "2px 0",
                                                paddingRight: "4px",
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                                overflowWrap: "break-word",
                                            }}
                                        >
                                            {item.quantity} x{" "}
                                            {item.name || ""}
                                        </td>
                                        <td
                                            className="amount-column"
                                            style={{
                                                width: "25%",
                                                textAlign: "center",
                                                fontSize: "8px",
                                                padding: "2px 0",
                                                paddingLeft: "2px",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {getItemAmount(item)}
                                        </td>
                                    </tr>
                                )
                            )}
                            {/* SUBTOTAL */}
                            <tr>
                                <td
                                    className="summary-label"
                                    style={{
                                        width: "75%",
                                        textAlign: "left",
                                        fontSize: "8px",
                                        padding: "2px 0",
                                    }}
                                >
                                    SubTotal
                                </td>
                                <td
                                    className="summary-amount"
                                    style={{
                                        width: "25%",
                                        textAlign: "center",
                                        fontSize: "8px",
                                        padding: "2px 0",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {Math.round(totalPrice)}
                                </td>
                            </tr>
                            {/* CGST */}
                            <tr>
                                <td
                                    className="summary-label"
                                    style={{
                                        width: "75%",
                                        textAlign: "left",
                                        fontSize: "8px",
                                        padding: "2px 0",
                                    }}
                                >
                                    CGST 2.5%
                                </td>

                                <td
                                    className="summary-amount"
                                    style={{
                                        width: "25%",
                                        textAlign: "center",
                                        fontSize: "8px",
                                        padding: "2px 0",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {Math.round(
                                        (2.5 / 100) *
                                        totalPrice
                                    )}
                                </td>
                            </tr>

                            {/* SGST */}
                            <tr>
                                <td
                                    className="summary-label"
                                    style={{
                                        width: "75%",
                                        textAlign: "left",
                                        fontSize: "8px",
                                        padding: "2px 0",
                                    }}
                                >
                                    SGST 2.5%
                                </td>

                                <td
                                    className="summary-amount"
                                    style={{
                                        width: "25%",
                                        textAlign: "center",
                                        fontSize: "8px",
                                        padding: "2px 0",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {Math.round(
                                        (2.5 / 100) *
                                        totalPrice
                                    )}
                                </td>
                            </tr>

                            {/* TOTAL */}
                            <tr>
                                <td
                                    className="summary-label total-label"
                                    style={{
                                        width: "75%",
                                        textAlign: "left",
                                        fontSize: "8px",
                                        padding: "2px 0",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Total Amount
                                </td>

                                <td
                                    className="summary-amount total-amount"
                                    style={{
                                        width: "25%",
                                        textAlign: "center",
                                        fontSize: "8px",
                                        padding: "2px 0",
                                        whiteSpace: "nowrap",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {Math.round(
                                        Number(
                                            cartPrice?.cartTotal || 0
                                        )
                                    )}
                                </td>
                            </tr>

                            {/* LINE */}
                            <tr>
                                <td
                                    colSpan="2"
                                >
                                    ------------------------------------------
                                </td>
                            </tr>

                            {/* GST */}
                            <tr>
                                <th
                                    colSpan="2"
                                    className="receipt-center"
                                    style={{
                                        fontSize: "8px",
                                        padding: "2px 0",
                                    }}
                                >
                                    GSTIN: {gst}
                                </th>
                            </tr>

                            {/* THANK YOU */}
                            <tr>
                                <th
                                    colSpan="2"
                                    className="receipt-center thank-you"
                                    style={{
                                        fontSize: "8px",
                                        padding: "2px 0",
                                    }}
                                >
                                    Thank you, visit again
                                </th>
                            </tr>

                        </tbody>
                    </table>

                </div>
            </div>
            {/* =====================================================
                BEVERAGE KOT
            ===================================================== */}
            {beverageItems.length > 0 && (
                <div className="print-page kot-page">
                    <div className="print-beverage-kot">

                        <table
                            className="receipt-table"
                            style={{
                                width: "100%",
                                tableLayout: "fixed",
                                borderCollapse: "collapse",
                            }}
                        >

                            <thead>

                                <tr>
                                    <th
                                        colSpan="2"
                                        className="receipt-center"
                                        style={{
                                            fontSize: "8px",
                                            padding: "2px 0",
                                        }}
                                    >
                                        BEVERAGE KOT
                                    </th>
                                </tr>

                                <tr>
                                    <td
                                        colSpan="2"
                                        className="receipt-center"
                                        style={{
                                            fontSize: "8px",
                                            padding: "2px 0",
                                        }}
                                    >
                                        Kots. {orderNumber}
                                    </td>
                                </tr>

                                <tr>
                                    <td
                                        colSpan="2"
                                    >
                                        ------------------------------------------
                                    </td>
                                </tr>

                            </thead>

                            <tbody>

                                {beverageItems.map(
                                    (item, index) => (
                                        <tr key={index}>
                                            <td
                                                colSpan="2"
                                                className="kot-item"
                                                style={{
                                                    textAlign: "left",
                                                    fontSize: "8px",
                                                    padding: "3px 0",
                                                    whiteSpace: "normal",
                                                    wordBreak: "break-word",
                                                }}
                                            >
                                                {item.quantity} x{" "}
                                                {item.name}
                                            </td>
                                        </tr>
                                    )
                                )}

                                <tr>
                                    <td
                                        colSpan="2"
                                    >
                                        ------------------------------------------
                                    </td>
                                </tr>

                            </tbody>

                        </table>

                    </div>
                </div>
            )}


            {/* =====================================================
                ITEM KOT
            ===================================================== */}
            {nonBeverageItems.length > 0 && (
                <div className="print-page kot-page">
                    <div className="print-item-kot">

                        <table
                            className="receipt-table"
                            style={{
                                width: "100%",
                                tableLayout: "fixed",
                                borderCollapse: "collapse",
                            }}
                        >

                            <thead>

                                <tr>
                                    <th
                                        colSpan="2"
                                        className="receipt-center"
                                        style={{
                                            fontSize: "8px",
                                            padding: "2px 0",
                                        }}
                                    >
                                        ITEM KOT
                                    </th>
                                </tr>

                                <tr>
                                    <td
                                        colSpan="2"
                                        className="receipt-center"
                                        style={{
                                            fontSize: "8px",
                                            padding: "2px 0",
                                        }}
                                    >
                                        Kots. {orderNumber}
                                    </td>
                                </tr>

                                <tr>
                                    <td
                                        colSpan="2"
                                    >
                                        ------------------------------------------
                                    </td>
                                </tr>

                            </thead>

                            <tbody>

                                {nonBeverageItems.map(
                                    (item, index) => (
                                        <tr key={index}>
                                            <td
                                                colSpan="2"
                                                className="kot-item"
                                                style={{
                                                    textAlign: "left",
                                                    fontSize: "8px",
                                                    padding: "3px 0",
                                                    whiteSpace: "normal",
                                                    wordBreak: "break-word",
                                                }}
                                            >
                                                {item.quantity} x{" "}
                                                {item.name}
                                            </td>
                                        </tr>
                                    )
                                )}

                                <tr>
                                    <td
                                        colSpan="2"
                                    >
                                        ------------------------------------------
                                    </td>
                                </tr>

                            </tbody>

                        </table>

                    </div>
                </div>
            )}

        </div>
    );
});

export default TakeOverReceipt;